export default ["Instructions", "Notes"];
